// src/components/Profile.jsx
import { useAuth } from "../AuthContext";
import { Nav, Button, Image } from 'react-bootstrap';
import './Profile.css'
import exit from '../img/exit.svg';

const Profile = () => {
  const { user, loading, loginWithGoogle, logout } = useAuth();

  return (
    <div className="ms-auto" style={{color:'#ddd',}}>
      {user && (
        <>
          <a href="/profile" className="me-2">
            <Image title={'Profile: '+user?.email} src={user.photoURL || "default-avatar.png"} alt={user?.email} style={{width: '32px',height: '32px',borderRadius: '50%',objectFit: 'cover'}} />
          </a>
          <Button className="rounded-circle bg-transparent" title="Logout" onClick={logout}><img src={exit} className="filter-white" height="24px" width="20px"/></Button>
        </>
      )}
    </div>
  );
};

export default Profile; 